import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.2 13.2C17.6103 13.2 17.9484 13.5088 17.9946 13.9067L18 14V15.6C18 16.8781 17.0009 17.9229 15.741 17.9959L15.6 18H4.4C3.12186 18 2.07707 17.0009 2.00407 15.741L2 15.6V14C2 13.5582 2.35817 13.2 2.8 13.2C3.21027 13.2 3.54841 13.5088 3.59462 13.9067L3.6 14V15.6C3.6 16.0103 3.90883 16.3484 4.3067 16.3946L4.4 16.4H15.6C16.0103 16.4 16.3484 16.0912 16.3946 15.6933L16.4 15.6V14C16.4 13.5582 16.7582 13.2 17.2 13.2ZM10 2C10.4418 2 10.8 2.35817 10.8 2.8V10.468L11.8343 9.43432C12.1227 9.14593 12.5765 9.12374 12.8903 9.36776L12.9657 9.43432C13.2541 9.7227 13.2763 10.1765 13.0322 10.4903L12.9657 10.5657L10.5657 12.9657L10.5305 12.9988L10.4762 13.0429L10.3873 13.1003L10.2971 13.143L10.2128 13.1713L10.094 13.1945L10 13.2L9.93981 13.1978L9.83942 13.1838L9.75029 13.1602L9.66142 13.1251L9.58343 13.0832L9.5066 13.0298C9.48123 13.0099 9.45709 12.9885 9.43431 12.9657L7.03431 10.5657C6.7219 10.2533 6.7219 9.74674 7.03431 9.43432C7.3227 9.14593 7.77649 9.12374 8.09032 9.36776L8.16569 9.43432L9.2 10.468V2.8C9.2 2.35817 9.55817 2 10 2Z",
		fill: "currentColor"
	})
});
export default SvgDownload;
